import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { selectedElement, updateContentElementById } from 'features/document/documentSlice';
import { isContactInfoElement } from 'utils/typeGuards';
import AlignmentRadioGroup from 'components/AlignmentRadioGroup/AlignmentRadioGroup';
import { Tag } from 'components/RadioTag/RadioTag';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { parseJustifyContentToAlignment, parseAlignmentToJustifyContent } from 'utils/alignmentParsers';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';
import { openInNewTab } from 'utils/openInNewTab';
import { selectQuote } from 'features/salesforce/salesforceSlice';

interface ContactInfoSidebarProps {
  currentElement: selectedElement;
}

export default function ContactInfoSidebar({ currentElement }: ContactInfoSidebarProps) {
  if (!isContactInfoElement(currentElement.data)) {
    return null;
  }

  const dispatch = useAppDispatch();
  const salesforceBaseUrl = useAppSelector(state => state.auth.salesforceBaseUrl);
  const quote = useAppSelector(selectQuote);

  const parsedJustifyContent = parseJustifyContentToAlignment(currentElement.data.style.justifyContent);

  const handleOnChangeAlignment = (newAlignment: Tag) => {
    dispatch(
      updateContentElementById({
        style: {
          justifyContent: parseAlignmentToJustifyContent(newAlignment.value),
        },
      })
    );
  };

  return (
    <Grid container direction='row' className='container' gap={2}>
      <Grid item xs={12}>
        <Typography fontSize={'16px'} fontWeight={500} marginBottom={'32px'}>
          Contact Info Block
        </Typography>
        {salesforceBaseUrl && quote && (
          <Button
            variant='outlined'
            sx={{
              padding: '8px 12px',
              display: 'flex',
              gap: '8px',
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: '600',
            }}
            onClick={() => openInNewTab(`${salesforceBaseUrl}/lightning/r/Quote/${quote.Id}/edit?`)}
          >
            <ModeEditRoundedIcon />
            Edit Contact Info In CRM
          </Button>
        )}
        <Typography fontSize={'14px'} fontWeight={500} marginTop={'32px'} marginBottom={'24px'}>
          Alignment
        </Typography>
        <Box maxWidth={'148px'}>
          <AlignmentRadioGroup
            selected={{ label: parsedJustifyContent, value: parsedJustifyContent }}
            handleChange={handleOnChangeAlignment}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
